import { SignIn, useAuth } from '@clerk/clerk-react'
import { Code, Mail, ShieldCheck, UserPlus } from 'lucide-react'
import { useEffect } from 'react'

/**
 * Branding sidebar component for the invitation page
 */
const InvitationSidebar = () => {
  return (
    <div className="hidden flex-col justify-center items-center p-12 lg:flex lg:w-1/2 bg-primary/10">
      <div className="max-w-xl">
        <Mail size={64} className="mb-8 text-primary" />
        <h1 className="mb-4 text-4xl font-bold">You&apos;ve Been Invited</h1>
        <p className="mb-6 text-xl text-muted-foreground">
          Accept your invitation to join the organization and access Sully.ai
          API features for your health AI integration.
        </p>

        <div className="mt-8 space-y-4">
          <h3 className="text-xl font-semibold">
            As a team member, you&apos;ll get:
          </h3>
          <ul className="space-y-3">
            <li className="flex items-center">
              <div className="p-1 mr-3 rounded-full bg-primary/20">
                <Code size={16} className="text-primary" />
              </div>
              <span>API management tools</span>
            </li>
            <li className="flex items-center">
              <div className="p-1 mr-3 rounded-full bg-primary/20">
                <ShieldCheck size={16} className="text-primary" />
              </div>
              <span>Secure access controls</span>
            </li>
            <li className="flex items-center">
              <div className="p-1 mr-3 rounded-full bg-primary/20">
                <UserPlus size={16} className="text-primary" />
              </div>
              <span>Collaboration with your team</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export const InvitationAccept = () => {
  return (
    <div className="flex w-full h-screen bg-background">
      <InvitationSidebar />
      {window.env?.CLERK_ENABLED ? (
        <ClerkSignInPage />
      ) : (
        <StandardInvitationPage />
      )}
    </div>
  )
}

function ClerkSignInPage() {
  const { signOut, isSignedIn } = useAuth()

  useEffect(() => {
    if (isSignedIn) {
      signOut().catch((error) => {
        console.error('Error signing out:', error)
      })
    }
  }, [isSignedIn, signOut])

  return (
    <div className="flex flex-col justify-center items-center p-6 w-full lg:w-1/2 md:p-12">
      <SignIn withSignUp={true} />
    </div>
  )
}

/**
 * Fallback invitation page for when Clerk is not enabled
 */
function StandardInvitationPage() {
  return (
    <div className="flex flex-col justify-center items-center p-6 w-full lg:w-1/2 md:p-12">
      <div className="w-full max-w-md">
        <h2 className="mb-4 text-2xl font-bold">Invitation Processing</h2>
        <p className="mb-2 text-muted-foreground">
          Authentication is not configured for invitation processing.
        </p>
      </div>
    </div>
  )
}
